import { BehaviorSubject, of } from 'rxjs';
import {
    GetInvoiceDetailRequest,
    GetInvoiceDetailService,
    InvoiceActivities
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { InvoiceDetail } from '@lsq-frontend/remote-services/enterprise/common';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class InvoiceDetailService {
    public static defaultTake = 25;
    public invoiceActivitiesRaw: InvoiceActivities[] = [];
    public invoiceActivities = new BehaviorSubject<InvoiceActivities[]>([]);
    public loading = new BehaviorSubject<boolean>(false);
    public totalCount = new BehaviorSubject<number>(0);
    public skip = new BehaviorSubject<number>(0);
    public take = new BehaviorSubject<number>(InvoiceDetailService.defaultTake);
    public request;
    public response;

    constructor(private _getInvoiceDetailService: GetInvoiceDetailService) {}

    public async getInvoiceDetail(invoiceKey) {
        this.loading.next(true);
        this.request = new GetInvoiceDetailRequest({
            invoiceKey: invoiceKey
        });
        this._getInvoiceDetailService.execute(this.request);
    }

    public async loadInvoiceActivities(): Promise<void> {
        this._getInvoiceDetailService.dataStream.subscribe((x) => {
            x.invoiceActivities.sort(
                (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
            );
            this.invoiceActivities.next(x.invoiceActivities);
            this.invoiceActivitiesRaw = x.invoiceActivities;
        });

        this.totalCount.next(this.invoiceActivitiesRaw?.length);
        this.loading.next(false);
    }
}
